<template>
  <div class = "upform">
    <el-form 
    ref="upForm" 
    :inline="true" 
    :model="upForm" 
    label-width="100px" 
    class="demo-ruleForm"
    >
      <el-form-item label="TargetID">
        <el-input v-model="upForm.Target_ChEMBL_ID"></el-input>
      </el-form-item>
      <br>
      <el-form-item label="Name">
        <el-input v-model="upForm.Name"></el-input>
      </el-form-item>
      <br>
      <el-form-item label="Originism">
        <el-input v-model="upForm.genus_species"></el-input>
      </el-form-item>
      <br>
      <el-form-item label="Uniprot">
        <el-input v-model="upForm.Uniprot"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="Save"
          >Save</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "predict",
  data() {
    return {
      upForm: {
        Target_ChEMBL_ID: '',
        genus_species: '',
        Name: '',
        Uniprot: '',
        id: ''
      },
      operate:''
    };
  },
  methods: {
    Save() {
      if(!this.upForm.Inflam_id || !this.upForm.MW ||!this.upForm.Name ||!this.SMILES){
        this.$message({
          message: 'Please enter complete',
          type: 'warning'
        });
      } else {
        if(this.operate) {
          //添加逻辑
          this.$http({
            url: "",
            methods: "get",
            params: this.upForm,
          }).then((data) => {
            console.log(data);
            this.$message('successfully');
            this.$router.back(1);
          });
        } else {
          //修改逻辑
          this.$http({
            url: "",
            methods: "get",
            params: this.upForm,
          }).then((data) => {
            console.log(data);
            this.$message('successfully');
            this.$router.back(1);
          });
        }
      }
    },
  },
  mounted(){
    let self = this
    if(self.$route.params.operate) {//添加
      self.operate = self.$route.params.operate
    } else {//修改
      self.$http({
        url: "/api/rdkit/queryTargetById",
        methods: "get",
        params: {
          id: self.$route.query.id
        },
      }).then((res) => {
          self.upForm = res.data.data
      });
    }
  }
};
</script>

<style scoped>
  .page-warp {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .down-load {
    display: flex;
    justify-content: flex-end;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>